import React, { useState } from 'react';
import { Row, Col, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import ScanSettingWarehouseTree from './ScanSettingWarehouseTree';
import AccountScanSettingTable from './AccountScanSettingTable';

const WarehouseAccountConfigTab: React.FC = () => {
    const { t } = useTranslation();
    const [warehouseId, setWarehouseId] = useState<number | undefined>();

    return (
        <Row gutter={16}>
            <Col span={6}>
                <Card size="small" title={t('pdaScanConfig.warehouseTree')}>
                    <ScanSettingWarehouseTree selectedWarehouseId={warehouseId} onSelect={setWarehouseId} />
                </Card>
            </Col>
            <Col span={18}>
                <AccountScanSettingTable warehouseId={warehouseId} />
            </Col>
        </Row>
    );
};

export default WarehouseAccountConfigTab;
